<template>
    <div id="finacyWrap">
        <!-- <div class="fixedIconBox" @click="toForm">
            <span class="titleText">需求填报</span>
        </div>
        <img src="../../images/finacy/finacyFirst.jpg" alt="" @click="toForm"  style="margin-top:20px;"/>
        <div class="textContent">
            <div class="duanluo" style="margin-top:0.6rem;">
                专为服装产业综合体平台内的企业提供天使梦想基金、让利性股权投资、政策性融资担保、小微企业集合债等多项金融服务,为企业发展于成长提供金融的坚实后盾。
            </div>
            <div class="titleSpot">
                <span class="xiaofangkuai"></span>
                <span class="titleInner">融资方式</span>
            </div>
            <div class="titleRed">
                一、天使梦想基金
            </div>
            <div class="duanluo">
                天使梦想基金按照“政府引导、市场运作、科学決策、防控风险”的原则,对余杭区符合条件的高层次人才创业创新项目进行投资。
            </div>
            <div class="titleRed">
                二、让利性股权投资
            </div>
            <div class="duanluo">
                让利性股权投资以优先股方式进行投资,投资期限般不超过3年,约定股息率最高不超过同期银行基准货款利率的85%。对重点产业、重点企业可给予股权投资额度放大、期限延长、约定股息率降低等优惠政策。投资的对象、额度、期限、预定股息率由各行业主管部门制定相关政策明确,资金运作采取市场化运营模式。
            </div>
            <div class="titleRed">
                三、政策性融资担保
            </div>
            <div class="duanluo">
                目前已与区内十余家银行签订战略合作协议。政策性融资担保业务是不以盈利为目的的准公共产品。
            </div>
            <div class="titleRed">
                四、还贷周转应急资金
            </div>
            <div class="duanluo">
                应急资金由区政府设立,总规模2亿。
            </div>
            <div class="titleRed">
                五、小微企业集合债
            </div>
            <div class="duanluo">
                “小微债”是经国家发改委核准,募集资金人民币3亿元,所募资金全部委托中国农业银行杭州余杭营业部以委托贷款的形式投放于余杭区内的小微企业。委贷年利率8-9%,按季支付利息,货款期限1-2年,单户最大金额900万元。
            </div>
            <div class="titleRed">
                六、直接投资
            </div>
            <div class="duanluo">
                对于特别优秀的企业,根据不同类别的产业资金和投资对象,采取注入资本金、直接参股、参与定向增发、跟进投资等不同的股权投资管理形式。
            </div>
        </div>
        <div class="longBtnBox">
            <button class="btn-red btn-long btn-shadow" @click="toForm">金融支持需求填报</button>
        </div> -->
    
        <div class="fixedIconBox" @click="toForm">
            <span class="titleText">需求填报</span>
        </div>
        <div class="firstSection">
            <div class="backBtn" @click="back"  v-if="!isFromYjj">
                <i class="el-icon-arrow-left"></i> 返回
            </div>
            <img src="../../images/newImages/bg_jinrongzhichi.png" alt="">
            <div class="floatBox">
                <div class="title bold">金融支持</div>
                <div class="subtitle">天使梦想基金 &nbsp;/ &nbsp;让利性股权投资 / &nbsp; 政策性融资担保 &nbsp;/&nbsp;小微企业集合债</div>
                <div class="btnBox">
                    <button class="btn-red" @click="toForm">预约申报</button>
                </div>
            </div>
        
        </div>
        <div class="textSection">
            <p class="duanluo liangduanduiqi">
                杭州金融控股集团有限公司（以下简称“金控集团”）将浙江省服装产业创新服务综合体开通专项通道，专为服装产业综合体平台内的企业提供天使梦想基金、让利性股权投资、政策性融资担保、小微企业集合债等多项金融服务，为企业发展于成长提供金融的坚实后盾。
            </p>
        </div>
        <div class="tuwenBlock">
            <div class="title">融资方式</div>
            <div class="tuwenOne">
                <div class="leftImg">
                    <img src="../../images/newImages/finacyLogo/tianshi.png" alt="" class="img">
                </div>
                <div class="rightText">
                    <div class="rightTitle">{{isFromYjj}}天使梦想基金</div>
                    <div class="contentText ">
                        天使梦想基金按照“政府引导、市场运作、科学决策、防控风险”的原则，对余杭区符合条件的高层次人才创业创新项目进行投资。
                    </div>
                </div>
            </div>
            <div class="tuwenOne">
                <div class="leftImg">
                    <img src="../../images/newImages/finacyLogo/rangli.png" alt="" class="img">
                </div>
                <div class="rightText">
                    <div class="rightTitle">让利性股权投资</div>
                    <div class="contentText">
                        <p>让利性股权投资以优先股方式进行投资，投资期限一般不超过3年，约定股息率最高不超过同期银行基准贷款利率的85%。对重点产业、重点企业可给予股权投资额度放大、期限延长、约定股息率降低等优惠政策。投资的对象、额度、期限、预定股息率由各行业主管部门制定相关政策明确，资金运作采取市场化运营模式。</p>

                    </div>
                </div>
            </div>
            <div class="tuwenOne">
                <div class="leftImg">
                    <img src="../../images/newImages/finacyLogo/zhengce.png" alt="" class="img">
                </div>
                <div class="rightText">
                    <div class="rightTitle">政策性融资担保</div>
                    <div class="contentText">
                        <p>杭州余杭政策性融资担保公司为金控集团全资子公司，2018年5月成立，目前已与区内十余家银行签订战略合作协议。政策性融资担保业务是不以盈利为目的的准公共产品。</p>

                    </div>
                </div>
            </div>
            <div class="tuwenOne">
                <div class="leftImg">
                    <img src="../../images/newImages/finacyLogo/huandai.png" alt="" class="img">
                </div>
                <div class="rightText">
                    <div class="rightTitle">还贷周转应急资金</div>
                    <div class="contentText">
                       <p>应急资金由区政府设立，总规模2亿。</p>
                    </div>
                </div>
            </div>
            <div class="tuwenOne">
                <div class="leftImg">
                    <img src="../../images/newImages/finacyLogo/xiaowei.png" alt="" class="img">
                </div>
                <div class="rightText">
                    <div class="rightTitle">小微企业集合债</div>
                    <div class="contentText">
                      <p>“余杭金控小微债”是经国家发改委核准，募集资金人民币3亿元，所募资金全部委托中国农业银行杭州余杭营业部以委托贷款的形式投放于余杭区内的小微企业。委贷年利率8-9%，按季支付利息，贷款期限1-2年，单户最大金额900万元。</p>

                    </div>
                </div>
            </div>
            <div class="tuwenOne">
                <div class="leftImg">
                    <img src="../../images/newImages/finacyLogo/zhijie.png" alt="" class="img">
                </div>
                <div class="rightText">
                    <div class="rightTitle">直接投资</div>
                    <div class="contentText">
                      <p>对于特别优秀的企业，根据不同类别的产业资金和投资对象，采取注入资本金、直接参股、参与定向增发、跟进投资等不同的股权投资管理形式。</p>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        ajaxCode,
        ajaxLogin
    } from '@/assets/request.js'
    import {
        setCookie,
        phoneReg,
        codeReg,
        filterPhoneNum,
        GetRequest
    } from '@/assets/common.js'
    export default {
        data() {
            return {
                paramObj: {},
                phone: '',
                code: '',
                isFromYjj:'',

            }
        },
        methods: {
            back(){
              this.$router.back()  
            },
            toForm() {
                this.$router.push({
                    name: 'FinacyForm'
                });
            },
            login() {
                let _this = this
                ajaxLogin(_this.phone, _this.code).then(res => {

                    let token = JSON.parse(res.data).token
                    let userId = JSON.parse(res.data).userId
                    console.log(token, userId)
                    sessionStorage.setItem("isLogined", "1")
                    sessionStorage.setItem("token", token)
                    sessionStorage.setItem("userId", userId)
                    setCookie("global_token", token, 10)
                }, (res) => {})
            }
        },
        mounted() {
           this.paramObj = GetRequest()
           console.log(this.paramObj )
           this.phone = this.paramObj.p
           this.code = this.paramObj.c
           if (this.phone && this.code) {
               this.login()
           }
           this.isFromYjj=this.code?true:false
           console.log(this.isFromYjj,'是否来自衣加加')
        }
    }
</script>

<style lang="less" scoped="scoped">
    img {
        width: 100%;
    }
    #finacyWrap{
        .firstSection{
            position: relative;
            .floatBox{
                position: absolute; top:1.5rem; left:0.4rem;
                .title{
                    font-size: 0.48rem;color:#333;font-weight: bold; line-height: 0.67rem;
                }
                .subtitle{font-size: 0.28rem;line-height: 0.38rem; width: 4rem;margin-top: 0.15rem;}
                .btnBox{
                    button{
                        position: absolute; top:1.2rem;right:-2.5rem;
                        padding:0.21rem 0; width: 1.97rem;font-size: 0.28rem;
                    }
                }
            }
        }
        .textSection{
            font-size: 0.36rem; color:#333; line-height: 0.68rem;padding:0.8rem 0.44rem; background: #fff;
        }
        .tuwenBlock{
            padding:0.8rem 0.32rem;
            .title{
                font-size: 0.3rem; font-weight: bold;line-height: 0.42rem; margin-bottom: 0.24rem;
            }
            .tuwenOne{
                background: #fff; padding:0.39rem 0.32rem; display: flex; margin-bottom: 0.4rem; border-radius:0.08rem; box-shadow: 0 2px 10px 0px rgba(9,9,9,0.15);
                .leftImg{
                    .img{
                        width: 0.88rem; height: 0.88rem;
                    }
                }
                .rightText{
                    padding-left:0.32rem;
                    .rightTitle{font-size: 0.34rem; line-height: 0.34rem; margin-bottom: 0.14rem;}
                    .contentText{font-size: 0.24rem;color:#999; line-height: 0.33rem; text-align: justify;}
                }
            }
        }
            
            
    }
</style>



// WEBPACK FOOTER //
// src/page/introPage/finacy.vue